const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"HEgnCRUFFksigOw93Zdc_"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nimba-regitorr@nimba-solution"]={id:"HEgnCRUFFksigOw93Zdc_"};
      